import React from "react";

type TableFooterProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLTableSectionElement>,
  HTMLTableSectionElement
> & {};

/**  Renders the Table Footer
 * @param props: TableFooterProps
 */
function TableFooter(props: TableFooterProps) {
  const { children } = props;
  return <tfoot>{children}</tfoot>;
}

export default TableFooter;
